export enum VPStages {
  PENDING_FN = 'Pending FN',
  NEEDS_DETAILS = 'Needs Details',
  DETAILS_SENT = 'Details Sent',
  PO_CREATED = 'PO Created',
  PASSED = 'Passed',
}
